<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div class="back">
  <app-user-header header="Edit Profile"></app-user-header>

  <div fxLayout="row wrap" fxLayoutAlign="space-around center">
    <form [formGroup]="userEditForm">
      <div>
        <input
          formControlName="userName"
          type="text"
          placeholder="Enter Your Name"
          [(ngModel)]="user.name"
          i18n
          class="notranslate"
        />
        <div *ngIf="userName.invalid && (userName.touched || userName.dirty)">
          <small
            class="error notranslate"
            *ngIf="userName.errors?.required"
            i18n
            >Username is required</small
          >
        </div>
      </div>

      <div>
        <input
          formControlName="userEmail"
          type="email"
          placeholder="Enter Email"
          [(ngModel)]="user.email"
          class="notranslate"
          i18n
        />
        <div
          *ngIf="userEmail.invalid && (userEmail.touched || userEmail.dirty)"
        >
          <small
            class="error notranslate"
            *ngIf="userEmail.errors?.pattern"
            i18n
            >Email is invalid</small
          >
        </div>
      </div>

      <div>
        <input
          formControlName="userPhone"
          type="phone"
          placeholder="Enter Phone Number"
          [(ngModel)]="user.phone"
          class="notranslate"
          i18n
        />
        <div
          *ngIf="userPhone.invalid && (userPhone.touched || userPhone.dirty)"
        >
          <small
            class="error notranslate"
            *ngIf="userPhone.errors?.pattern"
            i18n
            >Phone Number is invalid</small
          >
        </div>
      </div>

      <button type="submit" (click)="editDetails()" class="notranslate" i18n>
        SAVE CHANGES
      </button>
      <!-- <button type="submit" (click)="editDetails()" [disabled]="( userName.pristine) || ( userName.pristine && userEmail.pristine ) || ( userName.pristine && userPhone.pristine )">Save Changes</button> -->
    </form>
  </div>
  <p class="success">{{ userMessage }}</p>
  <div class="spacing"></div>
</div>
